{
  "mdata4load": [
    {"code": "11", "name": "institute_types", "title": "Institute Types", "for_sa": true},
    {"code": "12", "name": "boards", "title": "Boards Types", "for_sa": false},
    {"code": "13", "name": "classes", "title": "Class Master", "for_sa": false},
    {"code": "14", "name": "sections", "title": "Class Sections", "for_sa": false},
    {"code": "15", "name": "fin_period", "title": "Financial Periods", "for_sa": false},
    {"code": "16", "name": "sources", "title": "Inquiry Sources", "for_sa": true},
    {"code": "17", "name": "streams", "title": "Streams Master", "for_sa": false},
    {"code": "18", "name": "subjects", "title": "Subjects Master", "for_sa": false},
    {"code": "19", "name": "inquiry_status", "title": "Inquiry Status", "for_sa": true},
    {"code": "20", "name": "inquiry_mode", "title": "Inquiry Modes", "for_sa": true},
    {"code": "21", "name": "lead_status", "title": "Lead Status", "for_sa": false},
    {"code": "22", "name": "eligibility_status", "title": "Eligibility Status", "for_sa": false},
    {"code": "23", "name": "payment_modes", "title": "Payment Modes", "for_sa": false},
    {"code": "24", "name": "categories", "title": "Caste/Categories", "for_sa": false},
    {"code": "25", "name": "document_types", "title": "Document Types", "for_sa": false},
    {"code": "26", "name": "designations", "title": "Designations Master", "for_sa": false},
    {"code": "27", "name": "departments", "title": "Departments Master", "for_sa": false},
    {"code": "28", "name": "religions", "title": "Religions", "for_sa": false},
    {"code": "29", "name": "inv_item_cat", "title": "Inventory Item Category", "for_sa": false},
    {"code": "30", "name": "fee_heads", "title": "Fee Heads", "for_sa": false},
    {"code": "31", "name": "class_rooms", "title": "Class Room Names", "for_sa": false}
  ],
  "institute_types": [
    {"code": "uni", "name": "University"},
    {"code": "clg", "name": "College"},
    {"code": "scl", "name": "School"},
    {"code": "ctr", "name": "Coaching Center"}
  ],
  "boards": [
    {"code": "", "name": "N/A"},
    {"code": "CBSE", "name": "Central Board of Secondary Education"},
    {"code": "ICSE", "name": "Indian Certificate of Secondary Education"},
    {"code": "PSEB", "name": "Punjab School Education Board"},
    {"code": "HBSE", "name": "Haryana Board of School Education"},
    {"code": "NIOS", "name": "National Institute of Open Schooling"},
    {"code": "CAIE", "name": "Cambridge Assessment International Education"},
    {"code": "UGC",  "name": "University Grants Commission"}
  ],
  "fin_period": [
    {"code": "2024", "name": "2024-25"},
    {"code": "2025", "name": "2025-26"},
    {"code": "2026", "name": "2026-27"},
    {"code": "2027", "name": "2027-28"},
    {"code": "2028", "name": "2028-29"},
    {"code": "2029", "name": "2029-30"}
  ],
  "user_roles": [
    {"code": "spr", "name": "Super Admin"},
    {"code": "onr", "name": "Owner Admin"},
    {"code": "adm", "name": "User Admin"},
    {"code": "ppl", "name": "Principal"},
    {"code": "vpl", "name": "Vice Principal"},
    {"code": "tch", "name": "Teacher"},
    {"code": "std", "name": "Student"},
    {"code": "prt", "name": "Parent"},
    {"code": "hra", "name": "HR Admin"},
    {"code": "rec", "name": "Receptionist"},
    {"code": "con", "name": "Counsellor"},
    {"code": "hod", "name": "HOD Counsellor"},
    {"code": "acc", "name": "Accountant"},
    {"code": "lib", "name": "Librarian"},
    {"code": "war", "name": "Hostel Warden"},
    {"code": "trp", "name": "Transport Manager"},
    {"code": "xco", "name": "Examination Controller"}
  ],
  "sources": [
    {"code": "pc", "name": "Phone Call"},
    {"code": "ws", "name": "Website"},
    {"code": "gl", "name": "Google"},
    {"code": "fb", "name": "Facebook"},
    {"code": "ig", "name": "Instagram"},
    {"code": "wi", "name": "Walk-In"},
    {"code": "rf", "name": "Reference"},
    {"code": "ad", "name": "Advertisement"}
  ],
  "classes": [
    {"code": "prn", "name": "Pre-Nursery",    "sections": ["A","B","C"]},
    {"code": "nur", "name": "Nursery",        "sections": ["A","B","C"]},
    {"code": "lkg", "name": "Lower Kindergarten", "sections": ["A","B","C"]},
    {"code": "ukg", "name": "Upper Kindergarten", "sections": ["A","B","C"]},
    {"code": "01c", "name": "1st",            "sections": ["A","B","C"]},
    {"code": "02c", "name": "2nd",            "sections": ["A","B","C"]},
    {"code": "03c", "name": "3rd",            "sections": ["A","B","C"]},
    {"code": "04c", "name": "4th",            "sections": ["A","B","C"]},
    {"code": "05c", "name": "5th",            "sections": ["A","B","C"]},
    {"code": "06c", "name": "6th",            "sections": ["A","B","C"]},
    {"code": "07c", "name": "7th",            "sections": ["A","B","C"]},
    {"code": "08c", "name": "8th",            "sections": ["A","B","C"]},
    {"code": "09c", "name": "9th",            "sections": ["A","B","C"]},
    {"code": "10c", "name": "10th",           "sections": ["A","B","C"]},
    {"code": "11c", "name": "11th",           "sections": ["A","B","C"]},
    {"code": "12c", "name": "12th",           "sections": ["A","B","C"]}
  ],
  "sections": [
    {"code": "",  "name": "N/A"},
    {"code": "A", "name": "A"},
    {"code": "B", "name": "B"},
    {"code": "C", "name": "C"},
    {"code": "D", "name": "D"}
  ],
  "streams": [
    {"code": "",    "name": "N/A"},
    {"code": "arts","name": "Arts"},
    {"code": "com", "name": "Commerce"},
    {"code": "sci", "name": "Science"},
    {"code": "voc", "name": "Vocational"},
    {"code": "gen", "name": "General"},
    {"code": "any", "name": "Any Stream"}
  ],
  "subjects": [
    {"code": "pun",  "name": "Punjabi"},
    {"code": "hin",  "name": "Hindi"},
    {"code": "eng",  "name": "English"},
    {"code": "math", "name": "Mathematics"},
    {"code": "dra",  "name": "Drawing"},
    {"code": "mus",  "name": "Music"},
    {"code": "evs",  "name": "Environmental Studies"},
    {"code": "cmp",  "name": "Computer"},
    {"code": "gk",   "name": "General Knowledge"},
    {"code": "phed", "name": "Physical Education"},
    {"code": "phy",  "name": "Physics"},
    {"code": "che",  "name": "Chemistry"},
    {"code": "bio",  "name": "Biology"},
    {"code": "his",  "name": "History"},
    {"code": "psc",  "name": "Political Science"},
    {"code": "geo",  "name": "Geography"},
    {"code": "sci",  "name": "Science"},
    {"code": "sprt", "name": "Sports"},
    {"code": "med",  "name": "Medical"},
    {"code": "nmd",  "name": "Non-Medical"},
    {"code": "psy",  "name": "Psychology"},
    {"code": "csc",  "name": "Computer Science"},
    {"code": "eco",  "name": "Economics"},
    {"code": "soc",  "name": "Sociology"},
    {"code": "hsc",  "name": "Home Science"}
  ],
  "inquiry_status": [
    {"code": "adm", "name": "Admitted / Enrolled"},
    {"code": "con", "name": "Contacted"},
    {"code": "dup", "name": "Duplicate"},
    {"code": "fup", "name": "Follow-up"},
    {"code": "fsb", "name": "Form Submitted"},
    {"code": "int", "name": "Interview Scheduled"},
    {"code": "inv", "name": "Invalid"},
    {"code": "joi", "name": "Joined Other Institute"},
    {"code": "not", "name": "Not Interested"},
    {"code": "new", "name": "New Inquiry"},
    {"code": "hld", "name": "On Hold"},
    {"code": "pnd", "name": "Pending"},
    {"code": "reg", "name": "Registered"},
    {"code": "sho", "name": "Shortlisted"},
    {"code": "urv", "name": "Under Review"}
  ],
  "inquiry_mode": [
    {"code": "call",  "name": "Call"},
    {"code": "wa",    "name": "WhatsApp"},
    {"code": "sms",   "name": "SMS"},
    {"code": "email", "name": "Email"},
    {"code": "meet",  "name": "Meeting"},
    {"code": "visit", "name": "Visit"}
  ],
  "lead_status": [
    {"code": "pndg", "name": "Pending"},
    {"code": "intd", "name": "Interested"},
    {"code": "wltd", "name": "Waitlisted"},
    {"code": "acpd", "name": "Accepted"},
    {"code": "rejd", "name": "Rejected"}
  ],
  "eligibility_status": [
    {"code": "drft", "name": "Draft"},
    {"code": "actv", "name": "Active"},
    {"code": "arch", "name": "Archived"}
  ],
  "payment_modes": [
    {"code": "cash",   "name": "Cash"},
    {"code": "chq",    "name": "Cheque"},
    {"code": "upi",    "name": "UPI"},
    {"code": "cc",     "name": "Credit Card"},
    {"code": "online", "name": "Online"}
  ],
  "categories": [
    {"code": "GEN", "name": "General"},
    {"code": "BC",  "name": "Backward Class"},
    {"code": "OBC", "name": "Other Backward Class"},
    {"code": "SC", "name": "Scheduled Caste"},
    {"code": "ST", "name": "Scheduled Tribe"},
    {"code": "EWS", "name": "Economically Weaker Section"},
    {"code": "PH", "name": "Persons with Disability (PwD)"},
    {"code": "SPORT", "name": "Sports Quota"},
    {"code": "NRI", "name": "Non-Resident Indian"},
    {"code": "MGMT", "name": "Management Quota"}
  ],
  "document_types": [
    {"code": "BCt", "name": "Birth Certificate", "desc": "Original birth certificate issued by Municipal Corporation / hospital"},
    {"code": "ACd", "name": "Aadhaar Card", "desc": "UIDAI 12-digit Aadhaar card (student copy)"},
    {"code": "C8M", "name": "Class VIII Marksheet", "desc": "Board / school marksheet of Class VIII (8th standard)"},
    {"code": "CXM", "name": "Class X Marksheet", "desc": "Board marksheet of Class X (SSC / Matriculation)"},
    {"code": "C12", "name": "Class XII Marksheet", "desc": "Board marksheet of Class XII (HSC / Intermediate)"},
    {"code": "PCM", "name": "Previous Class Marksheet", "desc": "Marksheet of the immediately preceding class attended"},
    {"code": "TCt", "name": "Transfer Certificate (TC)", "desc": "TC issued by the last school / institution attended"},
    {"code": "MCt", "name": "Migration Certificate", "desc": "Required for students changing board or state"},
    {"code": "CCC", "name": "Caste / Category Certificate", "desc": "Government-issued certificate for SC / ST / OBC / EWS"},
    {"code": "ICt", "name": "Income Certificate", "desc": "Annual family income certificate from a competent authority (Tehsildar / SDM)"},
    {"code": "Rct", "name": "Domicile / Residence Certificate", "desc": "State domicile or local residence proof"},
    {"code": "PPh", "name": "Passport Size Photograph", "desc": "4 recent colour photographs (35mm × 45mm, white background)"},
    {"code": "FCt", "name": "Medical Fitness Certificate", "desc": "Certificate from a registered MBBS doctor declaring fitness for study"},
    {"code": "CCt", "name": "Character Certificate", "desc": "Issued by the principal / head of the previous institution"},
    {"code": "SCt", "name": "Sports / Achievement Certificate", "desc": "State / national level certificate for sports quota applicants"},
    {"code": "NRI", "name": "NRI Document (Passport / OCI)", "desc": "Passport copy or OCI card for NRI category applicants"},
    {"code": "ESC", "name": "Entrance Score Card", "desc": "Score card of the institutional or national entrance examination"},
    {"code": "DCt", "name": "Disability Certificate", "desc": "Certificate from Chief Medical Officer (CMO) for PwD category"}
  ],
  "designations": [
		{"code": "erp", "name": "ERP Admin"},
		{"code": "chm", "name": "Chairman"},
		{"code": "dir", "name": "Director"},
		{"code": "ppl", "name": "Principal"},
    {"code": "vpl", "name": "Vice Principal"},
    {"code": "hod", "name": "Head of Department"},
    {"code": "tch", "name": "Teacher"},
    {"code": "ltr", "name": "Lecturer"},
    {"code": "pro", "name": "Professor"},
    {"code": "lib", "name": "Librarian"},
    {"code": "lab", "name": "Lab Assistant"},
    {"code": "cop", "name": "Computer Operator"},
    {"code": "acc", "name": "Accountant"},
    {"code": "rec", "name": "Receptionist"},
    {"code": "hoc", "name": "Head Counsellor"},
    {"code": "con", "name": "Counsellor"},
		{"code": "adm", "name": "Administrator"},
    {"code": "hrm", "name": "HR Manager"},
    {"code": "drv", "name": "Driver"},
    {"code": "exe", "name": "Executive"}
  ],
  "departments": [
		{"code": "acd", "name": "Academic"},
    {"code": "adm", "name": "Administration"},
    {"code": "itd", "name": "IT Department"},
    {"code": "fin", "name": "Finance"},
    {"code": "hrd", "name": "HR Department"},
    {"code": "tpt", "name": "Transport"},
    {"code": "lib", "name": "Library"},
    {"code": "xam", "name": "Examination"},
    {"code": "cor", "name": "Co-Ordinator"},
    {"code": "com", "name": "Communication"},
    {"code": "hos", "name": "Hostel"}
  ],
  "religions": [
		{"code": "Hindu", "name": "Hindu"},
    {"code": "Sikh", "name": "Sikh"},
    {"code": "Buddhist", "name": "Buddhist"},
    {"code": "Jain", "name": "Jain"},
    {"code": "Muslim", "name": "Muslim"},
    {"code": "Christian", "name": "Christian"},
    {"code": "Other", "name": "Other"}
  ],
  "inv_item_cat": [
    {"code": "iic01", "name": "Stationery"},
    {"code": "iic02", "name": "Lab Equipment"},
    {"code": "iic03", "name": "IT Equipment"},
    {"code": "iic04", "name": "Furniture"},
    {"code": "iic05", "name": "Sports"},
    {"code": "iic06", "name": "Library"},
    {"code": "iic07", "name": "Maintenance"},
    {"code": "iic08", "name": "Canteen"},
    {"code": "iic09", "name": "Others"}
  ],
  "fee_heads": [
    {"code": "TFM", "name": "Tuition Fee (Monthly)"},
    {"code": "ADM", "name": "Admission Fee"},
    {"code": "LIB", "name": "Library Fee"},
    {"code": "LAB", "name": "Lab / Science Fee"},
    {"code": "SPT", "name": "Sports & Activity Fee"},
    {"code": "TRP", "name": "Transport Fee"},
    {"code": "HST", "name": "Hostel Fee"},
    {"code": "EXM", "name": "Examination Fee"},
    {"code": "CLB", "name": "Computer Lab Fee"},
    {"code": "MIS", "name": "Miscellaneous"},
    {"code": "DEV", "name": "Development / Building Fee"},
    {"code": "IDN", "name": "Identity Card Fee"}
  ],
  "class_rooms": [
    {"code": "RN-01", "name": "Room No. 101"},
    {"code": "RN-02", "name": "Room No. 102"},
    {"code": "RN-03", "name": "Room No. 103"},
    {"code": "RN-04", "name": "Room No. 104"},
    {"code": "RN-05", "name": "Room No. 201"},
    {"code": "RN-06", "name": "Room No. 202"},
    {"code": "RN-07", "name": "Room No. 203"},
    {"code": "RN-08", "name": "Room No. 204"},
    {"code": "RN-09", "name": "Lab 1 (Physics)"},
    {"code": "RN-10", "name": "Lab 2 (Chemistry)"},
    {"code": "RN-11", "name": "Lab 3 (Biology)"},
    {"code": "RN-12", "name": "Computer Lab"},
    {"code": "RN-13", "name": "Art Room"},
    {"code": "RN-14", "name": "Dance/Music Room"},
    {"code": "RN-15", "name": "Auditorium"}
  ]
}
